import React, { useContext, useState } from "react";
import { isMobile } from "react-device-detect";

import { ListingList, DetailsListingRow } from "../../components/listing";
import { UserContext } from "../../contexts";
import { Icon, IconButton } from "../../components/ui";
import html2pdf from "html2pdf.js";

import { Counter, ListingsTopButtons } from "../atoms";
import { ListingsFilters } from "../molecules";
import { useListingList } from "../useListingList";
import { StockCounter } from "../atoms/StockCounter";
import CompetitiveAnalysisBanner from "./CompetitiveAnalysisBanner";
import ListingSearch from "../molecules/ListingSearch";
import "./manage-listings.scss";

export function ManageListings() {
  const { user } = useContext(UserContext);
  const {
    count,
    totalBuyingPrice,
    totalListingPrice,
    listParams,
    onSearchQueryChange,
    onAdvancedFiltersChange,
    sort,
    setSort,
    filter,
    setFilter,
    inStock,
    setInStock,
    isConsignment,
    setConsignment,
  } = useListingList();
  const [brand, setBrand] = useState();

  const onDownload = () => {
    const element = document.body;

    const now = new Date();
    const timestamp = now.toISOString().replace(/[:.]/g, "-");
    const filename = `InStockListings_${timestamp}.pdf`;

    const opt = {
      margin: 0.5,
      filename: filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save();
  };

  // `ft-manage-listings` opts this page body into the Fontaine skin
  // (manage-listings.scss). Network and the lookbook sortable list share
  // `#listings-manage` and must keep the legacy skin — never move this
  // class onto them.
  return (
    <main
      id="listings-manage"
      className={`ft-manage-listings ${!isMobile ? "mt-3" : ""}`}
    >
      <div className="container">
        <CompetitiveAnalysisBanner setFilter={setFilter} setBrand={setBrand} />

        <div
          className={`${
            !isMobile
              ? "d-flex flex-wrap justify-content-between align-items-center p-3 pb-0 p-md-0 mt-4"
              : "px-3 pt-1"
          }  `}
        >
          <div className="flex-grow-1">
            <ListingSearch
              className={`listings ${isMobile ? "mb-1" : ""}`}
              placeholder="Quick search for products"
              onUpdate={onSearchQueryChange}
              onFiltersChange={onAdvancedFiltersChange}
              currentFilters={filter}
              inStock={inStock}
              setInStock={setInStock}
              isConsignment={isConsignment}
              setConsignment={setConsignment}
            />
          </div>
        </div>

        <div className={`p-3 list-container ${!isMobile ? "my-4" : "mt-3"}`}>
          <div className="d-flex justify-content-between align-items-center">
            <ListingsFilters
              {...{
                sort,
                setSort,
                filter,
                setFilter,
                inStock,
                setInStock,
                isConsignment,
                setConsignment,
              }}
            />
            {/* OPEN DECISION (not changed — see fe-dao-admin-sweep report).
                Lookbook cover templates are DAO-branded ("DAO Watches" / "No
                Logo" — listings/molecules/CoverSettings.jsx), so arguably this
                should be isRcOrDaoStaff. But this legacy page's button is only
                one of several entry points: RCLookbooksPage and RCListingsPage
                both render an ungated "+ New Lookbook", the "Lookbooks" tab in
                listings/constants/listingsTabs.jsx is ungated, and the
                /lookbooks/:id route is plain `requireMember`. Gating here alone
                would be cosmetic and inconsistent — Lookbooks needs one gate
                across all of them (or per-store cover branding). */}
            <ListingsTopButtons showLookbookBtn={user.is_dao_admin} />
          </div>
          {inStock || isConsignment ? (
            <div className="d-flex">
              <StockCounter
                count={count}
                totalBuyingPrice={totalBuyingPrice}
                totalListingPrice={totalListingPrice}
              />
              <IconButton
                className="ml-2"
                variant="ghost"
                size="sm"
                label="Download PDF"
                data-btn="listing-pdf-download"
                onClick={onDownload}
              >
                <Icon name="Download" size="sm" />
              </IconButton>
            </div>
          ) : (
            <Counter count={count} />
          )}
          {brand ? (
            <ListingList
              itemComponent={DetailsListingRow}
              limit={12}
              url={`/api/listings/competitive-analysis/missing/${brand}`}
              {...listParams}
            />
          ) : (
            <ListingList
              itemComponent={DetailsListingRow}
              limit={12}
              list={"uploaded"}
              {...listParams}
            />
          )}
        </div>
      </div>
    </main>
  );
}
